import { Pipe, PipeTransform } from "@angular/core";

/**
 * Visible name for the taxi business type. The API value stays the numeric
 * business type; only the words on screen change.
 */
export function mapRheroBusinessLabel(value: string | null | undefined): string {
  const text = (value || "").trim();
  if (
    text === "Taxi" ||
    text === "taxi" ||
    text === "label-title.taxi" ||
    text === "LABEL-TITLE.TAXI" ||
    text === "Ride Share" ||
    text === "ride share" ||
    text === "label-title.ride-share" ||
    text === "LABEL-TITLE.RIDE-SHARE" ||
    text === "Taxi hailing" ||
    text === "taxi hailing" ||
    text === "menu.taxi-hailing" ||
    text === "label-title.taxi-hailing"
  ) {
    return "R-Hero Ride";
  }
  return text;
}

@Pipe({
  name: "rheroBusiness",
  standalone: false
})
export class RheroBusinessPipe implements PipeTransform {
  transform(value: string | null | undefined): string {
    return mapRheroBusinessLabel(value);
  }
}
